var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("BluPool Login")])],1),_vm._v(" "),_c('v-content',[_c('v-container',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }